// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/animation-paused.svg';

/** Three flat bars shown in place of the playing waveform when paused. */
export const AnimationPaused = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
